const state = {
  transfer: {
    unsavedChanges: false,
  },
  receive: {
    unsavedChanges: false,
  },
}

const mutations = {
  SET_TRANSFER_UNSAVED_CHANGES(state, payload) {
    state.transfer = {
      ...state.transfer,
      unsavedChanges: payload,
    }
  },
  SET_RECEIVE_UNSAVED_CHANGES(state, payload) {
    state.receive = {
      ...state.receive,
      unsavedChanges: payload,
    }
  },
}

const actions = {
  /**
   * Description
   * @param {boolean} payload
   */
  setTransferUnsavedChanges({ commit }, payload) {
    commit('SET_TRANSFER_UNSAVED_CHANGES', payload)
  },
  /**
   * Description
   * @param {boolean} payload
   */
  setReceiveUnsavedChanges({ commit }, payload) {
    commit('SET_RECEIVE_UNSAVED_CHANGES', payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  strict: true,
}
